export default __webpack_public_path__ + "assets/img/t2.2312ee4.svg";